export default "__VITE_ASSET__DePOAXX8__"